// Resolve o clientHash/sellerId do catálogo atual a partir dos parâmetros de
// rota (fonte de verdade sempre que presentes na URL) com fallback pro que
// foi persistido no localStorage na última visita ao catálogo.
//
// Isso evita perder o rastreio de "pra qual catálogo redirecionar" quando o
// usuário passa por telas sem :clientHash/:sellerId na URL (login, cadastro,
// recuperação de senha) — sem depender de `navigate(-1)`/histórico do
// navegador, que quebra sempre que não há uma página anterior confiável.
export function resolveCatalogContext(params = {}) {
  const clientHash = params.clientHash || localStorage.getItem("@aqvex/clientHash") || null;
  const sellerId = params.sellerId || localStorage.getItem("@aqvex/sellerId") || null;

  // Se a URL trouxe os parâmetros, persiste — assim eles "grudam" como
  // fallback pra próxima tela que não tiver clientHash/sellerId na própria URL.
  if (params.clientHash) localStorage.setItem("@aqvex/clientHash", params.clientHash);
  if (params.sellerId) localStorage.setItem("@aqvex/sellerId", params.sellerId);

  return { clientHash, sellerId };
}

export function buildCatalogPath(clientHash, sellerId) {
  return clientHash && sellerId ? `/catalogo/${clientHash}/${sellerId}` : "/";
}

export function buildLoginPath(clientHash, sellerId) {
  return clientHash && sellerId ? `/login/${clientHash}/${sellerId}` : "/login";
}

export function buildRegisterPath(clientHash, sellerId) {
  return clientHash && sellerId ? `/register/${clientHash}/${sellerId}` : "/register";
}

export function buildForgotPasswordPath(clientHash, sellerId) {
  return clientHash && sellerId
    ? `/esqueci-senha/${clientHash}/${sellerId}`
    : "/esqueci-senha";
}
